import { IconButton } from "@material-ui/core";
import FilterListIcon from "@material-ui/icons/FilterList";
import React, { useState } from "react";
import ScrollPopup from "./ScrollPopup";
const ScrollToPopupOpener = ({ table }) => {
  // Popup open controls
  const [filterPopupOpen, setFilterPopupOpen] = useState(false);
  const [filterPopupAnchor, setFilterPopupAnchor] = useState(false);
  return (
    <>
      {" "}
      <IconButton
        onClick={(e) => {
          setFilterPopupOpen(true);
          setFilterPopupAnchor(e.currentTarget);
        }}
        size="small"
      >
        <FilterListIcon
          color={"secondary"}
          style={{ fontSize: "24px", padding: 0 }}
        />
      </IconButton>
      {filterPopupOpen && filterPopupAnchor ? (
        <ScrollPopup
          open={filterPopupOpen}
          anchor={filterPopupAnchor}
          onClose={() => {
            setFilterPopupOpen(false);
            setFilterPopupAnchor(null);
          }}
          table={table}
        />
      ) : null}
    </>
  );
};

export default React.memo(ScrollToPopupOpener, () => true);
